import { Link } from 'react-router-dom'
import { EstadoVazio } from './Estados'
import { IconeIndicador } from './Icones'
import { TEXTOS } from '../lib/glossario'

/**
 * O que uma tela apurada por mês mostra quando nenhum mês tem dado.
 *
 * **É o estado em que a UAT começa**, e era o único sem tela: `useChecklistDeRecebimento`,
 * `useConformidadeDeGmud` e `usePainelDoIad` têm `enabled: competencia.length > 0`, e uma consulta
 * desabilitada do TanStack Query fica em `isPending` para sempre — não é "carregando", é
 * "nunca vai carregar". A tela então pulsava um esqueleto cinza eterno, que é a "tela quebrada" do
 * cenário 39 do roteiro. Base limpa não é falha, e o texto diz o que precisa acontecer para haver
 * o que mostrar.
 *
 * O caminho de saída aponta para o fechamento porque é lá que a planilha da fiscalização é
 * carregada — é o ato que faz um mês passar a existir para o sistema inteiro.
 *
 * @returns o estado vazio das telas por competência
 */
export function SemCompetencia() {
  const t = TEXTOS.semCompetencia
  return (
    <EstadoVazio
      icone={<IconeIndicador className="h-9 w-9" />}
      titulo={t.titulo}
      ajuda={t.ajuda}
      acao={
        <Link to="/fiscalizacao" className="text-sm font-medium text-sky-800 hover:underline">
          {t.acao}
        </Link>
      }
    />
  )
}
